module.exports = "<a (click)=\"rowEdit($event)\" class=\"br-icn-edit realign-top link\"></a>\n<a (click)=\"rowSave($event);\" class=\"br-icn-save realign-top mr-4 link\"></a>\n<a (click)=\"rowCancel($event)\" class=\"br-icn-cancel realign-top link\"></a>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/row-controls/row-controls.component.html
// module id = ../../../../../src/app/brds/widgets/row-controls/row-controls.component.html
// module chunks = 10